import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell, MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useChat } from "@/context/ChatContext";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const DOT = { alta: "bg-[#E53935]", media: "bg-[#F39200]", bassa: "bg-[#2A62A0]" };

export const BellMenu = () => {
  const [alerts, setAlerts] = useState([]);
  const { unread } = useChat();
  const nav = useNavigate();
  useEffect(() => { api.get("/home/alerts").then(({ data }) => setAlerts(data.alerts || [])).catch(() => setAlerts([])); }, []);
  const chat = unread?.total || 0;
  const tot = alerts.length + (chat > 0 ? 1 : 0);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid="shell-bell-btn" aria-label="Avvisi" className="relative h-10 w-10 rounded-lg flex items-center justify-center text-navy hover:bg-sage transition-colors">
          <Bell className="h-5 w-5" />
          {tot > 0 && <span data-testid="shell-bell-count" className="absolute top-1 right-1 min-w-[16px] h-4 px-1 rounded-full bg-[#E53935] text-white text-[10px] font-bold flex items-center justify-center">{tot > 99 ? "99+" : tot}</span>}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-[70vh] overflow-y-auto">
        <DropdownMenuLabel className="text-navy">Avvisi</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {chat > 0 && (
          <DropdownMenuItem onClick={() => nav("/chat")} className="cursor-pointer gap-2" data-testid="shell-bell-chat">
            <MessageCircle className="h-4 w-4 text-navy" /> {chat} {chat === 1 ? "messaggio non letto" : "messaggi non letti"} in Chat
          </DropdownMenuItem>
        )}
        {alerts.map((a, i) => (
          <DropdownMenuItem key={i} onClick={() => a.route && nav(a.route)} className="cursor-pointer items-start gap-2" data-testid={`shell-bell-alert-${i}`}>
            <span className={`mt-1.5 h-2 w-2 shrink-0 rounded-full ${DOT[a.livello] || DOT.bassa}`} />
            <span className="text-sm leading-snug">{a.titolo}{a.responsabile ? <span className="block text-xs text-slate-500">{a.responsabile}</span> : null}</span>
          </DropdownMenuItem>
        ))}
        {tot === 0 && <p className="px-2 py-3 text-sm text-slate-500" data-testid="shell-bell-empty">Nessun avviso: è tutto in ordine.</p>}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
